import { mapValues } from 'lodash';
/**
 * Version 35 migrations registration summary widget - Air request
 * - Adding default configurations for air request on registration summary
 */
export default function v37(website) {
  return {
    ...website,
    eventVersion: 37,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'ContactPlanner') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            style: {
              ...layoutItem.config.style,
              contactUsModalStyles: {
                ...layoutItem.config.style.contactUsModalStyles,
                modalPlannerNameStyles: {
                  styleMapping: 'body1'
                },
                modalFieldStyles: {
                  styleMapping: 'input',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    }
                  }
                },
                modalLabelStyles: {
                  styleMapping: 'label',
                  customSettings: {
                    text: {
                      textAlign: 'left'
                    }
                  }
                },
                modalSendButtonStyles: {
                  styleMapping: 'primaryButton',
                  customSettings: {
                    text: {
                      textAlign: 'center'
                    }
                  }
                }
              }
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
